// Upload public Promotion image assets through Firebase Storage. Dedicated event
// and internal paths enforce manager/entitlement or global-admin authorization.
// JPEG, PNG and WebP files are limited to 5 MB; UUID names avoid overwrites.
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../firebase";

const IMAGE_EXTENSIONS = { "image/jpeg": "jpg", "image/png": "png", "image/webp": "webp" };
export const PROMOTION_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

export const validatePromotionImage = (file) => {
  if (!IMAGE_EXTENSIONS[file?.type] || file.size > PROMOTION_IMAGE_MAX_BYTES) {
    throw new Error("Choose JPEG, PNG, or WebP images no larger than 5 MB each.");
  }
};

export const uploadPromotionImage = async (file, eventId = null) => {
  validatePromotionImage(file);
  const filename = `${crypto.randomUUID()}.${IMAGE_EXTENSIONS[file.type]}`;
  const storagePath = eventId
    ? `eventAssets/${eventId}/promotions/${filename}`
    : `promotionAssets/internal/${filename}`;
  const objectRef = ref(storage, storagePath);
  await uploadBytes(objectRef, file, { contentType: file.type });
  return { url: await getDownloadURL(objectRef), storagePath };
};
